import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("h2", {
  class: "font-semibold text-base",
  style: {"color":"#1A1421"}
}, "Detail Konfigurasi", -1)
const _hoisted_2 = { class: "flex flex-row w-full gap-4" }
const _hoisted_3 = { class: "flex flex-row w-full gap-4" }
const _hoisted_4 = { class: "space-y-2 pt-2" }
const _hoisted_5 = /*#__PURE__*/_createVNode("div", { class: "text-12px font-normal text-gray-lp-500 max-w-md" }, " Klik tombol di bawah ini untuk mengaktifkan atau menonaktifkan status ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_MultipleSelectProduct = _resolveComponent("MultipleSelectProduct")!
  const _component_InternationalCountryTable = _resolveComponent("InternationalCountryTable")!
  const _component_Card = _resolveComponent("Card")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    customClass: "edit-cod-international",
    class: "h-full",
    fullPage: "",
    title: "Ubah COD Internasional Klien",
    loading: _ctx.isLoading,
    error: _ctx.isError,
    errorType: _ctx.errorType,
    onTryAgain: _ctx.fetchDetail,
    onBack: _ctx.goBack,
    leavePageConfirmation: _ctx.showLeavePageConfirmation,
    "vertical-separator": false,
    noPaddingSubData: true,
    "use-padding-vertical": "",
    headerNewLayout: "",
    "onUpdate:leavePageConfirmation": _cache[6] || (_cache[6] = ($event: any) => (_ctx.showLeavePageConfirmation = $event)),
    onLeavePage: _ctx.confirmLeavePage,
    onCancelLeavePage: _cache[7] || (_cache[7] = ($event: any) => (_ctx.showLeavePageConfirmation = false))
  }, {
    "top-right": _withCtx(() => [
      _createVNode(_component_LpButton, {
        textColor: "white",
        iconV2: "",
        iconLeft: "save",
        color: "red-lp-2400",
        title: "Simpan",
        onClick: _ctx.submit,
        disabled: !_ctx.isFormValid
      }, null, 8, ["onClick", "disabled"])
    ]),
    data: _withCtx(() => [
      _createVNode(_component_Card, {
        rounded: "xl",
        class: "flex p-4 flex-col gap-4"
      }, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode("div", _hoisted_2, [
            _createVNode(_component_DataWrapper, {
              label: "ID Konfigurasi",
              class: "w-full"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  modelValue: _ctx.form.configId,
                  disabled: "",
                  disableBackground: "bg-gray-lp-2800"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: "Nama Konfigurasi",
              class: "w-full"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  modelValue: _ctx.$t(_ctx.form.configName),
                  disabled: "",
                  disableBackground: "bg-gray-lp-2800"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createVNode("div", _hoisted_3, [
            _createVNode(_component_DataWrapper, {
              label: "Deskripsi",
              class: "w-full"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  type: "textarea",
                  textAreaRows: "3",
                  modelValue: _ctx.form.configDescription,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.configDescription = $event)),
                  maxLength: "255",
                  minLength: "3",
                  showMaxLength: "",
                  resizableTextarea: ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: "Jenis pengiriman",
              class: "w-full"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_MultipleSelectProduct, {
                  status: "active",
                  class: "my-1.5",
                  placeholder: "Pilih jenis pengiriman",
                  modelValue: _ctx.form.products,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.products = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_InternationalCountryTable, {
            modelValue: _ctx.form.countries,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.countries = $event)),
            "is-active-status": _ctx.form.status,
            "is-valid": _ctx.isTableValid,
            "onUpdate:is-valid": _cache[4] || (_cache[4] = ($event: any) => (_ctx.isTableValid = $event)),
            onValidityChange: _ctx.onTableValidityChange
          }, null, 8, ["modelValue", "is-active-status", "is-valid", "onValidityChange"])
        ]),
        _: 1
      }),
      _createVNode(_component_Card, {
        rounded: "xl",
        class: "flex p-4 flex-col gap-4"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_DataWrapper, {
            label: "Status Konfigurasi COD",
            fontStyleLabel: "text-sm font-semibold text-gray-lp-300"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_4, [
                _hoisted_5,
                _createVNode(_component_Toggle, {
                  onChange: _ctx.onUpdateStatus,
                  modelValue: _ctx.form.status,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.status = $event)),
                  textActive: "Aktif",
                  textInactive: "Tidak Aktif"
                }, null, 8, ["onChange", "modelValue"])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["loading", "error", "errorType", "onTryAgain", "onBack", "leavePageConfirmation", "onLeavePage"]))
}